import config from '../config';

const getExhibitionsByCountry = async (countryId) => {
  const response = await fetch(`${config.API_URL}/exhibitions/country/${countryId}`);
  return response.json();
};

const getExhibitionById = async (exhibitionId) => {
  console.log('Calling getExhibitionById with ID:', exhibitionId);
  console.log('API URL:', `${config.API_URL}/exhibitions/${exhibitionId}`);
  const response = await fetch(`${config.API_URL}/exhibitions/${exhibitionId}`);
  const data = await response.json();
  console.log('getExhibitionById response:', data);
  return data;
};

const getExhibitionPhotos = async (exhibitionId) => {
  console.log('Calling getExhibitionPhotos with ID:', exhibitionId);
  console.log('API URL:', `${config.API_URL}/exhibitions/${exhibitionId}/photos`);
  const response = await fetch(`${config.API_URL}/exhibitions/${exhibitionId}/photos`);
  const data = await response.json();
  console.log('getExhibitionPhotos response:', data);
  return data;
};

export default {
  getExhibitionsByCountry,
  getExhibitionById,
  getExhibitionPhotos
};